import styled from "styled-components";
import getImageURL from "../../../../../controllers/getImageURL";
import calculateAge from "../../../../../controllers/calculateAge";
import { useContext, useEffect, useState } from "react";
import CustomButton from "../../../../helperComponents/CustomButton";
import { serverLine } from "../../../../../controllers/network/serverLine";
import Context from "../../../../../Context";
import ActivityRechargeBillLine from "./ActivityRechargeBillLine";
import getAfterDiscountPrice from "../../../../../controllers/getAfterDiscountPrice";
import { useTranslation } from "react-i18next";

const Section = styled.div`
  display: flex;
  flex-direction: column;
  background: var(--surface);
  color: var(--element);
  border: 1px solid var(--border);

  align-items: center;
  gap: 40px;
  width: auto;
  border-radius: 10px;
  flex-direction: column;
  padding: 30px;
  align-items: flex-start;

  @media (max-width: 900px) {
    width: 100%;
  }
`;

const ImageSection = styled.img`
  height: 60px;
  width: 60px;
  object-fit: cover;
  border-radius: 100px;
`;

const Text = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
`;

const Title = styled.div`
  font-weight: 900;
  font-size: 19px;
  font-family: var(--headingFont);
`;

const SubHeading = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
  flex-wrap: wrap;
  @media (max-width: 900px) {
    flex-direction: column;
  }
`;

const Title2 = styled.div``;

const TopPart = styled.div`
  display: flex;
  flex-direction: row;
  gap: 20px;
  align-items: center;
`;

const Inputs = styled.div`
  display: flex;
  gap: 15px;
  flex-direction: column;
  width: 100%;
`;

const Text2 = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
`;

export default function ActivityRechargeRequestCard({
  item,
  activityTypeIdVsData,
}) {
  const { t } = useTranslation();

  const { membershipPlans } = useContext(Context);

  const [dealt, setDealt] = useState(false);

  const [amount, setAmount] = useState(0);
  const [discountedAmount, setDiscountedAmount] = useState(0);

  useEffect(() => {
    let newVal = getAfterDiscountPrice({
      total: amount,
      membershipPlans,
      user: item.author,
    });
    setDiscountedAmount(newVal);
  }, [amount]);

  if (dealt) return null;

  return (
    <Section>
      <TopPart>
        <ImageSection
          src={getImageURL(item.author.profileImage, true)}
        ></ImageSection>

        <Text>
          <Title>
            {item.author.firstName} {item.author.lastName}
          </Title>

          <SubHeading>
            <Title2>{item.author.phoneNumber}</Title2>
            <Title2>Age: {calculateAge(item.author.dateOfBirth)}</Title2>
          </SubHeading>
        </Text>
      </TopPart>

      <Text2>
        <ActivityRechargeBillLine
          type={item.participationCountType}
          itemID={item.activityTypeID}
          quantity={1}
          setAmount={setAmount}
          typeIdVsData={activityTypeIdVsData}
        />

        {amount !== discountedAmount ? (
          <Title2>
            {t("discountedAmount")}: {discountedAmount}
          </Title2>
        ) : null}
      </Text2>

      <Inputs>
        <CustomButton
          onClick={submit}
          style={{ width: "100%", background: "var(--surface)" }}
        >
          Accept
        </CustomButton>

        <CustomButton
          onClick={deleteItem}
          style={{ width: "100%", background: "var(--surface)" }}
        >
          Delete
        </CustomButton>
      </Inputs>
    </Section>
  );

  function submit() {
    serverLine.post("/admin/activity-recharge-request", {
      requestID: item._id,

      action: "ACCEPT",
      amount,
    });
    window.popupAlert("Done");
    setDealt(true);
  }

  function deleteItem() {
    serverLine.post("/admin/activity-recharge-request", {
      requestID: item._id,
      action: "DENY",
    });
    window.popupAlert("Done");
    setDealt(true);
  }
}
